const noSchedule = {
  id: 'emptyInterval.noSchedule',
}

const textIds = {
  noSchedule,
}

export default textIds
